import {
  LISTEN_TO_DEPLOYMENT_VERSION,
  REFRESH_OPERATION_RULES,
  REFRESH_WORKFLOW_TYPES,
} from './stores/EventStore/eventConstants'
import EventsStore from './stores/EventStore/Events.store'

// Ball-in-Court rules and workflow configurations are loaded once at startup
// and kept current by a subscription, which only delivers changes made while
// it is connected. Re-read them after the socket reconnects, the app resumes,
// or the tab sat hidden long enough for the socket to have been dropped.
const RESYNC_MIN_INTERVAL_MS = 60 * 1000
const RESYNC_AFTER_HIDDEN_MS = 5 * 60 * 1000

export default class CommonContainer {
  protected eventsStore: EventsStore

  private lastResyncAt: number = null
  private hiddenAt: number = null

  protected registerGlobalEventListeners() {
    window.addEventListener('online', this.listenToDeploymentVersion)

    document.addEventListener('resume', this.onAppResume)

    document.addEventListener('visibilitychange', this.onVisibilityChange)
  }

  // Handed to createGraphClient. Not throttled: a reconnect is the moment
  // subscriptions resume, so a re-read just before it would leave a gap.
  protected onSubscriptionsReconnected = () => {
    this.resyncLiveData(true)
  }

  private onAppResume = () => {
    this.listenToDeploymentVersion()
    this.resyncLiveData()
  }

  private onVisibilityChange = () => {
    if (!window.RT) {
      setTimeout(this.listenToDeploymentVersion, 1000)
    }

    if (document.visibilityState === 'hidden') {
      this.hiddenAt = Date.now()
      return
    }

    const wasHiddenLong =
      this.hiddenAt !== null &&
      Date.now() - this.hiddenAt >= RESYNC_AFTER_HIDDEN_MS
    this.hiddenAt = null

    if (wasHiddenLong) {
      this.resyncLiveData()
    }
  }

  private resyncLiveData(isForced: boolean = false) {
    const now = Date.now()
    const isTooSoon =
      this.lastResyncAt !== null &&
      now - this.lastResyncAt < RESYNC_MIN_INTERVAL_MS

    if (!this.eventsStore || (isTooSoon && !isForced)) {
      return
    }

    this.lastResyncAt = now
    this.eventsStore.dispatch(REFRESH_OPERATION_RULES)
    this.eventsStore.dispatch(REFRESH_WORKFLOW_TYPES)
  }

  private listenToDeploymentVersion = () => {
    if (!window.RT) {
      this.eventsStore.dispatch(LISTEN_TO_DEPLOYMENT_VERSION)
    }
  }
}
